'use es6';

import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { getDefaultRowValue } from 'FormsUI/utils/ComparisonTool';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ColorRow = ({
  value
}) => /*#__PURE__*/_jsxs("span", {
  children: [value, /*#__PURE__*/_jsx(ColorSwatch, {
    size: 10,
    color: value,
    marginInlineStart: "200"
  })]
});
export const DateRow = ({
  value
}) => value.format('LLL');
export const PercentageRow = ({
  value
}) => /*#__PURE__*/_jsx(FormattedPercentage, {
  precision: 2,
  value: value
});
export const BooleanRow = ({
  value
}) => value ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "comparison.cards.settings.isOn"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "comparison.cards.settings.isOff"
});
export const YesNoRow = ({
  value
}) => value ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "comparison.cards.settings.isYes"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "comparison.cards.settings.isNo"
});
export const DefaultRow = ({
  value
}) => /*#__PURE__*/_jsx("div", {
  style: {
    direction: 'rtl'
  },
  children: /*#__PURE__*/_jsx(TruncateString, {
    reverse: true,
    maxInlineSize: "150px",
    children: getDefaultRowValue(value)
  })
});